/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
import './src/styles/global.scss';
import './src/styles/css/global.css';
import './src/styles/css/components.css';
import './src/cookie-consent/styles/main.css';

import React from 'react';
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from 'react-query';

import Page from './src/components/page';
import ConstructionBanner from './src/components/construction-banner';

const isUnderConstruction = process.env.GATSBY_CONSTRUCTION_MODE === 'true';

const queryClient = new QueryClient();

export const replaceHydrateFunction = () => {
    return (element, container) => {
        const root = ReactDOM.createRoot(container);
        root.render(element);
    };
};

export const onClientEntry = () => {
  import('./src/cookie-consent/CookieConsent.js').then(({ CookieConsent }) => {
    const cc = new CookieConsent({
      display: {
        trigger: 'onLoad',
        position: 'bottom-left',
        theme: 'light',
        backdrop: true,
        shakeAnimation: true,
        hideAfterAction: true,
      },
      compliance: {
        gdpr: true,
        googleConsentMode: true,
      },
      language: {
        auto: false,
        default: 'de',
      },
      storage: {
        cookieName: 'jr_cookie_consent',
        // Root-Domain (z. B. .juwelier-roller.de), damit der Magento-Checkout im iFrame auf
        // der shop.-Subdomain den Consent lesen kann. Nicht gesetzt (dev/localhost) => host-only.
        cookieDomain: process.env.GATSBY_CONSENT_COOKIE_DOMAIN || null,
        cookiePath: '/',
        expiration: 365,
        secure: true,
        sameSite: 'Lax',
      },
      links: {
        privacy: '/datenschutz/',
        imprint: '/impressum/',
      },
      categories: {
        necessary: { enabled: true, readOnly: true, preselected: true },
        analytics: { enabled: true, readOnly: false, preselected: false },
        marketing: { enabled: true, readOnly: false, preselected: false },
        functional: { enabled: false, readOnly: false, preselected: false },
        personalization: { enabled: false, readOnly: false, preselected: false },
      },
      cookies: {
        necessary: [
          {
            provider: 'Juwelier Roller',
            cookies: [
              { name: 'jr_cookie_consent', purpose: 'Speichert Cookie-Einstellungen', expiry: '1 Jahr', type: 'LocalStorage' },
            ],
          },
          {
            provider: 'Trusted Shops',
            cookies: [
              { name: 'trustedShops', purpose: 'Käuferschutz und Bewertungs-Widget (vertragsrelevant)', expiry: 'Sitzung', type: 'HTTP Cookie' },
            ],
          },
          {
            provider: 'Homie (yourhomie.ai)',
            cookies: [
              { name: 'homieBot', purpose: 'AI-Chat-Widget; überträgt Chat-Eingaben zur Beantwortung an yourhomie.ai', expiry: 'Sitzung', type: 'Script / API' },
            ],
          },
        ],
        analytics: [
          {
            provider: 'Google Analytics (via GTM)',
            cookies: [
              { name: '_ga', purpose: 'Unterscheidet Nutzer', expiry: '2 Jahre', type: 'HTTP Cookie' },
              { name: '_gid', purpose: 'Unterscheidet Nutzer (24h)', expiry: '24 Stunden', type: 'HTTP Cookie' },
            ],
          },
        ],
        marketing: [
          {
            provider: 'Google Ads',
            cookies: [
              { name: '_gcl_au', purpose: 'Werbewirksamkeit', expiry: '3 Monate', type: 'HTTP Cookie' },
            ],
          },
        ],
      },
    });

    window.__cookieConsent = cc;
  });
};

// eslint-disable-next-line import/prefer-default-export
export const wrapPageElement = ({ element }) => (
    <QueryClientProvider client={queryClient}>
        <Page>
            {isUnderConstruction && <ConstructionBanner />}
            {element}
        </Page>
    </QueryClientProvider>
);
